import { Injectable } from '@angular/core'

import { ModelRepository  } from './../../../model-repository/model-repository'
import { ModelRepositoryAdapter } from './../../../model-repository/model-repository-adapter'
import { CartItemAssociation } from '../../models/cart-item-association'

@Injectable()
export class CartItemAssociationService extends ModelRepositoryAdapter<CartItemAssociation> {

  constructor(private _modelRepository: ModelRepository) {
    super(_modelRepository, CartItemAssociation)
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/data/services/cart-item-association/cart-item-association.service.ts